export default __webpack_public_path__ + "static/media/walletpasses_icon.0ee60e81.png";